import { TreeIconList } from './types';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const iconList: TreeIconList = {
    isDigital: {
        class: 'is-digital-icon',
        materialIcon: 'power_settings_new',
    },
}

export function isIcon(attribute: { key: string, value: boolean }) {
    return attribute.key in iconList && attribute.value === true;
}

@Component({
    selector: 'cl-basic-tree-icon',
    templateUrl: './basic-tree-icon.component.html',
    styleUrls: ['basic-tree-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicTreeIconComponent {
    @Input() iconName: string;

    get icon() {
        if (!(this.iconName in iconList)) {
            throw new Error('Icon not supported. Please add it into list.');
        }
        return iconList[this.iconName];
    }
}
